var map = {
	"./DE.png": "4749",
	"./EL.png": "8644",
	"./EN.png": "b273",
	"./ES.png": "e7db",
	"./FR.png": "773c",
	"./GB.png": "ae65",
	"./PT.png": "615f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";